import React from 'react'
import clockAlertIcon from 'assets/icons/clock-alert-outline.png'
import * as S from './styles'

interface ReminderAlertProps {
  title: string
  description: string
  onClick?: () => void
}

const ReminderAlert: React.FC<ReminderAlertProps> = ({
  title,
  description,
  onClick,
}) => {
  return (
    <S.Container onClick={onClick}>
      <S.IconWrapper>
        <img src={clockAlertIcon} alt="Alerta" />
      </S.IconWrapper>
      <S.Content>
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
      </S.Content>
    </S.Container>
  )
}

export default ReminderAlert
